import React, { useEffect, useState } from 'react';
import './DeliveryInfo.less';
import { Input, Button } from 'antd';
import { useHistory } from 'react-router-dom';
import { useAuth } from '@isocel/front-common';

import { getPackingFlowFromVoucher, validateTransportVoucher } from '../../../queries/api/packaging-flow'; // Import the fetchPackagingFlowByVoucher function
import { usePackagingFlow } from '../../../context/PackagingFlowContext';
import { PackagingFlowDirection, PackagingFlowItem, StoreUser } from '../../../queries/api/types';
import { useNotification } from '../../notification/Notification';

const DeliveryInfo: React.FC = () => {
    const history = useHistory();
    const [transportNumber, setTransportNumber] = useState('');
    const { setSelectedStore, setPackageFlow, setFlowType, setVoucher } = usePackagingFlow();
    const { showNotification } = useNotification();
    const handleTransportNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setTransportNumber(e.target.value);
    };

    const { user } = useAuth();
    const storeId = (user as StoreUser)?.store || '';

    useEffect(() => {
        setFlowType(PackagingFlowDirection.RecivedInStore);
    });

    const handleNextClick = async () => {
        try {
            const validateTransport = await validateTransportVoucher(transportNumber, 1, storeId);
            if (validateTransport.voucherFound === true) {
                showNotification('error', 'Erreur', 'Un flux de réception a déjà été créé pour ce bon de transport');
                return;
            } else {
                const response = await getPackingFlowFromVoucher(transportNumber);
                const res = response;
                if (res) {
                    res.flowType = PackagingFlowDirection.RecivedInStore;
                    setSelectedStore(res.recipient);
                    setVoucher(res.transportVoucher || '');
                    const updatedResponse = {
                        ...res,
                        packages: res.packages.map((pkg: PackagingFlowItem) => ({
                            ...pkg,
                            goodCount: pkg.goodCount === 0 && pkg.badCount === 0 ? pkg.shippedQuantity : pkg.goodCount,
                        })),
                    };
                    setPackageFlow(updatedResponse);
                    history.push(`/recipientMovement/${(user as StoreUser)?.store || ''}`);
                } else {
                    /*  history.push(`/registration/${storeId}`); */
                    showNotification(
                        'error',
                        'Erreur',
                        "Aucun flux de réception n'a été trouvé pour ce bon de transport. Veuillez contacter votre SCA."
                    );
                }
            }
        } catch (error) {
            console.log('error', error);
        }
    };

    return (
        <div className="delivery-info-page">
            <div className="title">
                <h2>Veuillez saisir les informations de la livraison</h2>
            </div>
            <label className="field-label" htmlFor="transport-number-input">
                N de bon de transport
            </label>
            <Input
                id="transport-number-input"
                placeholder="Saisir le N de bon de transport"
                value={transportNumber}
                onChange={handleTransportNumberChange}
                className="input-field"
            />
            <div className="submit-button">
                <Button type="primary" onClick={handleNextClick} disabled={!transportNumber}>
                    Suivant
                </Button>
            </div>
        </div>
    );
};

export default DeliveryInfo;
